import EnteringTextAnimation from './EnteringTextAnimation'

export default EnteringTextAnimation
